import { Checkbox, CheckboxSize, Show } from "shared/components";
import { AssigneeSearchInput } from "./AssigneeSearchInput";
import { HugeiconsIcon } from "@hugeicons/react";
import { UserMinus01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { User } from "views/settings-users/types";

import { NO_ASSIGNEE_ID, NOOP } from "./constants";
import { AssigneeUserRow } from "./AssigneeUserRow";

interface AssigneeFilterContentProps {
  search: string;
  onSearchChange: (value: string) => void;
  sortedUsers: User[];
  isLoading: boolean;
  selectedUserIds: number[] | null;
  authId?: number;
  onToggleUser: (userId: number) => void;
  onCancel: () => void;
}

export const AssigneeFilterContent = ({
  search,
  onSearchChange,
  sortedUsers,
  isLoading,
  selectedUserIds,
  authId,
  onToggleUser,
  onCancel
}: AssigneeFilterContentProps) => (
  <>
    <div className="flex w-full items-center justify-between gap-3 px-4 py-3 border-b border-alpha-40">
      <span className="text-sm font-semibold text-content-1000">
        Assigned to
      </span>
      <button
        type="button"
        onClick={onCancel}
        className="text-sm font-medium text-primary-500 focus-visible:outline-none focus-visible:ring-0"
      >
        Cancel
      </button>
    </div>
    <AssigneeSearchInput
      id="assignee-filter-search"
      placeholder="Search assignee"
      value={search}
      onChange={onSearchChange}
    />
    <div className="max-h-[300px] overflow-y-auto">
      <Show if={!search}>
        <div
          className="flex w-full items-center justify-start gap-3 px-4 py-2.5 hover:bg-alpha-40 cursor-pointer"
          onClick={() => onToggleUser(NO_ASSIGNEE_ID)}
        >
          <Checkbox
            checked={selectedUserIds?.includes(NO_ASSIGNEE_ID) || false}
            size={CheckboxSize.SM}
            wrapperClassName="!w-auto !flex-none !p-0 justify-center"
            onChange={NOOP}
          />
          <HugeiconsIcon
            icon={UserMinus01Icon}
            className="text-content-1000"
            size={20}
          />
          <p className="text-base font-medium text-content-1000">No assignee</p>
        </div>
      </Show>
      <Show if={isLoading}>
        <div className="px-4 py-2.5 text-content-400 text-sm">
          Loading users...
        </div>
      </Show>
      <Show if={!isLoading && sortedUsers.length === 0}>
        <div className="px-4 py-2.5 text-content-400 text-sm">
          No users found
        </div>
      </Show>
      {sortedUsers.map((user) => (
        <AssigneeUserRow
          key={user.id}
          userId={user.id}
          name={user.name}
          isSelected={selectedUserIds?.includes(user.id) || false}
          isCurrentUser={user.id === authId}
          onToggle={onToggleUser}
        />
      ))}
    </div>
  </>
);
